<!--
 * @Author: lee 15472300+li-shaoang@user.noreply.gitee.com
 * @Date: 2025-06-16 17:53:28
 * @LastEditors: lee 15472300+li-shaoang@user.noreply.gitee.com
 * @LastEditTime: 2025-06-17 14:31:30
 * @FilePath: \zhucai_user\src\pages\member\child\bm.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="my-container">
    <div class="my-title">订单列表</div>
    <div class="my-content">
      <div class="my-search-box">
        <div class="my-dateRange">
          <el-date-picker
            v-model="getListData.StartDate"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="订单开始时间"
          >
          </el-date-picker>
          <span class="heng">-</span>
          <el-date-picker
            v-model="getListData.EndDate"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="订单结束时间"
          >
          </el-date-picker>
        </div>
        <el-select
          v-model="getListData.TypeID"
          placeholder="订单类型"
          clearable
          @change="getList"
        >
          <el-option
            v-for="(it, i) in statusOptions"
            :key="i"
            :label="it.label"
            :value="it.value"
          />
        </el-select>
        <el-button @click="getList" class="search-btn">搜索</el-button>
      </div>
      <ul class="my-tabs">
        <li
          class="my-tabs-item"
          :class="{ active: getListData.StatusID == item.value }"
          @click="changeTabs(item)"
          v-for="(item, index) in tabs"
          :key="index"
        >
          {{ item.label }}
        </li>
      </ul>
      <div v-if="tableData.length > 0" v-loading="isLoading" class="my-table">
        <div
          v-for="(item, index) in tableData"
          :key="index"
          @click="gotoDetail(item)"
          class="my-table-item"
        >
          <div class="my-table-item-top">
            <div>
              <span>订单编号：{{ item.OrdersNo }}</span
              ><span class="ml50">订单时间：{{ item.AddTime }}</span>
            </div>
            <div class="StatusID">
              {{ item.StatusTxt }}
            </div>
          </div>
          <div class="my-table-item-bottom">
            <div class="my-table-item-bottom-left">
              <div class="ImgPath">
                <img :src="item.ImgPath" @error="imgError" alt="" />
              </div>
              <div class="RelatedName">{{ item.RelatedName }}</div>
              <div class="Amount mr100 b600">¥ {{ item.Amount }}</div>
              <div class="PayedAmount">
                实付：<span class="Amount b600">
                  {{ item.PayedAmount ? "¥" + item.PayedAmount : "-" }}</span
                >
              </div>
            </div>
            <div class="my-table-item-bottom-right">
              <el-button
                v-if="item.StatusID == 0"
                class="table-btn"
                @click.stop="toPay(item)"
              >
                付款
              </el-button>
              <el-button class="table-btn" @click.stop="hanldDetail(item)">
                查看
              </el-button>
              <el-button
                v-if="item.StatusID == 0"
                class="table-btn"
                @click.stop="cancel(item)"
              >
                取消
              </el-button>
            </div>
          </div>
        </div>
      </div>
      <el-empty description="暂无内容" :image="empty1" v-else />
      <my-pagination
        :total="total"
        :pageSize="getListData.PageSize"
        v-model="getListData.PageIndex"
      ></my-pagination>
    </div>
  </div>
</template>

<script>
import { MyOrdersCancel, GetMyOrdersList } from "@/api/member";
import myPagination from "@/components/myPagination.vue";
import { handleTree } from "@/util/fcn";
export default {
  components: { myPagination },
  name: "order",
  data() {
    return {
      tabs: [
        { label: "全部", value: -1 },
        { label: "待付款", value: 0 },
        { label: "已完成", value: 1 },
        { label: "已取消", value: 9 },
      ],
      statusOptions: [
        { label: "课程", value: 1 },
        { label: "资料", value: 2 },
        { label: "练习", value: 3 },
        { label: "报名", value: 4 },
      ],
      isLoading: true,
      total: 0,
      tableData: [],
      getListData: {
        Title: "",
        StartDate: "",
        EndDate: "",
        StatusID: -1,
        TypeID: "",
        PageIndex: 1,
        PageSize: 6,
      },
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    changeTabs(item) {
      this.getListData.StatusID = item.value;
      this.getList();
    },
    hanldDetail(data) {
      this.$router.push({
        path: "/member/orderDetail",
        query: {
          OrdersID: data.OrdersID,
        },
      });
    },
    toPay(data) {
      this.$router.push({
        path: "/confirmOrder",
        query: {
          OrdersID: data.OrdersID,
        },
      });
    },
    gotoDetail(item) {
      if (item.RelatedType == "1") {
        this.$router.push({
          path: "/courseDetail",
          query: {
            CourseID: item.RelatedID,
          },
        });
      } else if (item.RelatedType == "2") {
        this.$router.push({
          path: "/materialDetail",
          query: {
            MaterialID: item.RelatedID,
          },
        });
      } else if (item.RelatedType == "3") {
        this.$router.push({
          path: "/qbankDetail",
          query: {
            ExerciseID: item.RelatedID,
          },
        });
      } else if (item.RelatedType == "4") {
        this.$router.push({
          path: "/apipcEnrollDetail",
          query: {
            SubjectID: item.RelatedID,
          },
        });
      }
    },
    cancel(data) {
      this.$confirm("此操作将取消订单, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        // type: "warning",
        customClass: "my-messagebox",
      }).then(() => {
        MyOrdersCancel({
          OrdersID: data.OrdersID,
        }).then((res) => {
          if (res.code == 0) {
            this.$message.success(res.msg);
            this.getList();
          } else {
          }
        });
      });
    },
    getList() {
      this.isLoading = true;
      const data = this.getListData;
      GetMyOrdersList(data).then((res) => {
        this.isLoading = false;
        this.total = res.count;
        this.tableData = res.data;
      });
    },
  },
  watch: {
    "getListData.PageIndex"() {
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
.width510 {
  ::v-deep .el-dialog {
    width: 510px;
  }
}
.el-select {
  ::v-deep .el-input__inner {
    width: 201px;
    height: 47px;
    background: #f6f8fc;
    border-radius: 23px;
    border: 1px solid #e6e6e6;
  }
}
.el-date-editor {
  width: 180px;
  height: 47px;
  ::v-deep .el-input__inner {
    width: 180px;
    height: 47px;
    background: #f6f8fc;
    border-radius: 23px;
    border: 1px solid #e6e6e6;
  }
}
.my-table {
  width: 100%;

  .my-table-item {
    border: 1px solid #e6e6e6;
    margin-bottom: 10px;
    .my-table-item-top {
      height: 57px;
      background: #f6f8fc;
      font-weight: 400;
      font-size: 16px;
      color: #333333;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 20px;
      .StatusID {
        font-size: 16px;
        color: #1d79ff;
      }
    }
    .my-table-item-bottom {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 20px;
      .my-table-item-bottom-left {
        display: flex;
        align-items: center;
        .ImgPath {
          width: 150px;
          height: 112px;
          border-radius: 6px;
          img {
            width: 100%;
            height: 100%;
            border-radius: 6px;
          }
        }
        .RelatedName {
          margin-left: 20px;
          margin-right: 100px;
          width: 379px;
          font-size: 20px;
          color: #333333;
          font-weight: 400;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        .Amount {
          font-weight: bold;
          font-size: 20px;
          color: #e12a14;
        }
        .PayedAmount {
          font-size: 16px;
          color: #666666;
        }
      }
    }
  }
}
</style>
